'use client';

import { useEffect, useEffectEvent } from 'react';
import { usePageHistory } from '../pageWrappers/usePageHistory';
import { usePathname } from 'next/navigation';
import { WebApi404Data } from '../dataCollector/types/dataCollector.types';
import { WebAPIMetadata } from '../webApiTypes/elements/WebAPIMetadata';
import { WebAPIBase } from '../webApiTypes/base/WebAPIPage';
import {
	type DOPRouterEvent,
	onDOPRouterEvent,
} from '../routing/useDOPRouterEvent';

export const UpdatePageHistory = ({
	status,
	opPartner,
	providerType,
	url,
}: {
	status: WebAPIBase['status'] | WebApi404Data['status'];
	opPartner: WebAPIMetadata['op:partner'] | undefined;
	providerType: string;
	url: WebAPIBase['url'];
}) => {
	const [, dispatchPageHistory] = usePageHistory();
	const pathname = usePathname();

	const handlePageHistoryUpdate = useEffectEvent((event: DOPRouterEvent) => {
		if (event.detail.destination !== 'newPathname') return;

		if (status === '404') {
			dispatchPageHistory({
				partners: undefined,
				providerType: undefined,
				pathname,
			});
		} else {
			dispatchPageHistory({
				partners: opPartner,
				providerType: providerType,
				pathname: url,
			});
		}
	});
	useEffect(() => {
		return onDOPRouterEvent(handlePageHistoryUpdate);
	}, []);
	return null;
};
